import { render, staticRenderFns } from "./Circoscrizione.vue?vue&type=template&id=e0b898c4&"
import script from "./Circoscrizione.vue?vue&type=script&lang=js&"
export * from "./Circoscrizione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports